export default {
      id: "script-text-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#script-text",
      toString: function () {
        return this.url;
      }
    }